module.exports = __webpack_public_path__ + "img/svg-circle.620878b8.svg";